// The landing page is served directly from public/index.html.
// React mounts to a hidden <div id="root" /> and intentionally renders nothing
// so the static landing markup remains untouched.
function App() {
  return null;
}

export default App;
